import { ProductionRoute } from '@/features/production-routes/api/ProductionRouteModel'
import { GenericCombobox, Label } from '@/common'
import { TrashIcon } from '@/common/components/icons'
import { useCallback, useMemo } from 'react'

export default function ProductionRouteSelector({
  label,
  productionRouteId,
  onProductionRouteUpdate,
  disabled,
  tooltip,
  tooltipPlacement,
  tooltipSize,
  productionRoutes
}: {
  label?: string
  productionRouteId: string
  tooltip?: string
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
  cnCode?: string
  onProductionRouteUpdate: (productionRouteId: string) => void
  disabled?: boolean
  productionRoutes: ProductionRoute[]
}) {
  const productionRouteOptions = useMemo(() => {
    return (
      productionRoutes?.map(productionRoute => ({
        label: productionRoute.name,
        value: productionRoute.id
      })) || []
    )
  }, [productionRoutes])

  const selectedProductionRoute =
    productionRouteOptions.find(productionRoute => productionRoute.value === productionRouteId) ||
    null

  const onChange = useCallback(
    (productionRouteId: string | null) => {
      onProductionRouteUpdate(productionRouteId || '')
    },
    [onProductionRouteUpdate]
  )

  return !selectedProductionRoute ? (
    <GenericCombobox
      label={label}
      disabled={disabled}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      tooltipSize={tooltipSize}
      items={productionRouteOptions}
      value={selectedProductionRoute}
      onChange={productionRoute => onChange(productionRoute?.value || '')}
    />
  ) : (
    <div>
      <Label
        className="mb-1"
        tooltip={tooltip}
        tooltipPlacement={tooltipPlacement}
        tooltipSize={tooltipSize}
      >
        {label}
      </Label>
      <div
        className="flex items-center justify-between whitespace-nowrap text-sm text-green-600 bg-green-300 rounded-xs py-2.5 px-4 border border-green-600"
        title={selectedProductionRoute.label}
      >
        <p className="overflow-hidden font-semibold text-ellipsis">
          {selectedProductionRoute.label}
        </p>
        {!disabled && (
          <button onClick={() => onChange(null)}>
            <TrashIcon className="size-6 ml-1" />
          </button>
        )}
      </div>
    </div>
  )
}
